import { parsePhoneNumberFromString } from "libphonenumber-js";

const EMAIL_PATTERN = /^[^\s@,]+@[^\s@,]+\.[^\s@,]+$/;

export const isValidEmailList = (value, { required = false } = {}) => {
  const entries = String(value || "")
    .split(",")
    .map((entry) => entry.trim())
    .filter(Boolean);

  if (!entries.length) return !required;

  return entries.every((entry) => EMAIL_PATTERN.test(entry));
};

export const isValidReferencePhone = (value, defaultCountry = "GB") => {
  const phoneValue = String(value || "").trim();
  if (!phoneValue) return true;

  const phone = parsePhoneNumberFromString(
    phoneValue.replace(/^00/, "+"),
    defaultCountry,
  );

  return Boolean(phone?.isValid());
};
